// Bundle JS ultra-minimal pour les landing pages verbes
// Charge uniquement Stimulus et le landing_controller

import "@hotwired/turbo-rails"
import { Application, Controller } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Globals nécessaires pour stimulus-shim (utilisé par les controllers profiles/*)
window.StimulusApplication = Application
window.StimulusController = Controller

// Import landing controller
import LandingController from "./controllers/landing_controller"
application.register("landing", LandingController)

// AI buttons (Claude, Perplexity, Gemini)
import LandingAiButtonsController from "./controllers/landing_ai_buttons_controller"
application.register("landing-ai-buttons", LandingAiButtonsController)

// Circle wipe — transition entre pages (landing/storytelling/explore)
import CircleTransitionController from "./controllers/shared/circle_transition_controller.js"
application.register("circle-transition", CircleTransitionController)

// WebMCP: Discovery tool pour les landing pages domaines-verbes
// Import dynamique car le controller utilise stimulus-shim qui lit window.StimulusController
import("./controllers/profiles/webmcp_discovery_controller.js").then(({ default: ctrl }) => {
  application.register("profiles--webmcp-discovery", ctrl)
})
